import { FC } from 'react';
import * as Styled from './MemberProfile.styled';
import { DineRewardsCloseIcon } from '@maverick/icons/dist/DineRewardsCloseIcon';
import { useRouter } from 'next/navigation';
import { ReturnIcon } from '@maverick/icons/dist/ReturnIcon';
import { IconEdit } from '@maverick/icons/dist/IconEdit';
import { useIsMobile } from '../../../../../../shared/hooks/useIsMobile';
import { Icon } from '../../../../../ui/Icon';

interface MemberProfileHeaderProps {
	onClickCloseButton: () => void;
	onClickEditButton: () => void;
	isEditing: boolean;
}

export const MemberProfileHeader: FC<MemberProfileHeaderProps> = ({
	onClickCloseButton,
	onClickEditButton,
	isEditing,
}) => {
	const isMobile = useIsMobile();
	const router = useRouter();

	const handleOnKeyDown = (ev: React.KeyboardEvent, action: () => void) => {
		if (ev.key === 'Enter' || ev.key === ' ') {
			ev.preventDefault();
			action();
		}
	};

	const onClickBackButton = () => {
		window.location.hash = '#menu';
		window.dispatchEvent(new HashChangeEvent('hashchange'));
		router.push('/dashboard/member-profile#menu');
	};

	const RenderTitle = () => {
		return (
			<Styled.Title>
				<Styled.HeaderTitle tabIndex={0}>{'View Member Profile'}</Styled.HeaderTitle>
				{!isEditing && (
					<Styled.EditProfileButton
						data-testid='edit-button'
						tabIndex={0}
						aria-label='edit profile button'
						onClick={onClickEditButton}
						onKeyDown={(ev) => handleOnKeyDown(ev, onClickEditButton)}
					>
						{'EDIT'}
						<Styled.EditIcon>
							<Icon icon={IconEdit} customSize />
						</Styled.EditIcon>
					</Styled.EditProfileButton>
				)}
			</Styled.Title>
		);
	};

	const RenderHeader = () => {
		if (isMobile) {
			return (
				<Styled.HeaderMobile data-testid='member-profile-header'>
					<Styled.MobileHeaderRow>
						<Styled.BackButton
							onClick={onClickBackButton}
							tabIndex={0}
							aria-label='back button'
							onKeyDown={(ev) => handleOnKeyDown(ev, onClickBackButton)}
						>
							<Icon data-testid='back-button' icon={ReturnIcon} customSize />
						</Styled.BackButton>
						<Styled.Logout
							aria-label='log-out button link'
							tabIndex={0}
							data-testid='logout-button'
							href='/api/auth/logout'
						>
							{'LOG OUT'}
						</Styled.Logout>
						<Styled.IconContainer
							aria-label='exit button'
							tabIndex={0}
							onClick={onClickCloseButton}
							onKeyDown={(ev) => handleOnKeyDown(ev, onClickCloseButton)}
						>
							<Icon data-testid='close-button' icon={DineRewardsCloseIcon} customSize />
						</Styled.IconContainer>
					</Styled.MobileHeaderRow>
					{RenderTitle()}
				</Styled.HeaderMobile>
			);
		}
		return (
			<Styled.Header data-testid='member-profile-header'>
				<Styled.LogoutContainer>
					<Styled.Logout
						aria-label='log-out button link'
						tabIndex={0}
						data-testid='logout-button'
						href='/api/auth/logout'
					>
						{'LOG OUT'}
					</Styled.Logout>
				</Styled.LogoutContainer>
				{RenderTitle()}
				<Styled.HeaderClose>
					<Styled.IconContainer
						tabIndex={0}
						aria-label='close button'
						data-testid='close-button'
						onClick={onClickCloseButton}
						onKeyDown={(ev) => handleOnKeyDown(ev, onClickCloseButton)}
					>
						<Icon icon={DineRewardsCloseIcon} customSize />
					</Styled.IconContainer>
				</Styled.HeaderClose>
			</Styled.Header>
		);
	};

	return RenderHeader();
};
